<template>
  <div class="w-100">
    <div class="overlay" :class="post_drawer ? 'open' : ''" @click="closeMedia()"></div>
    <div class="report-detail-modal" :class="post_drawer ? 'open' : ''">
      <div class="detail-modal report" v-if="post_drawer">
        <div class="detail-profile-wrap">
          <div class="detail-profile-img-area">
            <img class="detail-profile_img report pointer" :src="influencer.profile_picture_url" @error="imgError()" @click="openInfluencer(influencer.account_name)" />
          </div>
          <div class="detail-profile-name-area">
            <div class="detail-profile-name report pointer" @click="openInfluencer(influencer.account_name)">
              {{ influencer.account_name }}
              <font-awesome-icon :icon="['fal', 'info-circle']" style="margin-left: 3px; color: #666" />
            </div>
            <div class="detail-location">
              <span v-if="post.location">
                <font-awesome-icon :icon="['fas', 'map-marker-alt']" style="margin-right: 3px" />
                {{ post.location }}・
              </span>
              <span>{{ post.timestamp }}</span>
            </div>
          </div>
          <div class="flex-space"></div>
          <div class="detail-link">
            <a :href="'https://www.instagram.com/p/' + post.shortcode + '/'" target="_blank">
              <el-button type="info" size="medium" style="margin-left: 10px">Instagram→</el-button>
            </a>
          </div>
        </div>
        <div class="detail-profile-report-num" v-if="this.post_list.length > 1">
          <div class="detail-profile-report-num-title">
            <font-awesome-icon :icon="['fal', 'images']" style="margin-right: 5px" />
            {{ post_list.length }}件の投稿
          </div>
          <div class="flex-space"></div>
          <el-button type="info" size="mini" @click="transitionMedia('minus')" :disabled="target_index == 0">
            <font-awesome-icon :icon="['far', 'chevron-left']" />
          </el-button>
          <el-button type="info" size="mini" @click="transitionMedia('plus')" :disabled="target_index == post_list.length - 1">
            <font-awesome-icon :icon="['far', 'chevron-right']" />
          </el-button>
        </div>
        <div class="detail-report-middle" :style="reportDetailHeight(post.media_type)">
          <div class="detail-report-left">
            <div class="detail-engage-area report">
              <div class="report-media-profile-num detail">
                <div class="report-media-profile-num-box detail">
                  <div class="report-media-profile-num-title">フォロワー</div>
                  <div class="report-media-profile-num-num">
                    <span class="report-media-profile-num-digit detail"> {{ Math.floor(post.followers_count / 1000) / 10 }} </span>万人
                  </div>
                </div>
                <div class="report-media-profile-num-box detail">
                  <div class="report-media-profile-num-title">
                    EG
                    <el-tooltip :content="'エンゲージメント数(Engagement)を示しています。\nいいねとコメントの合計です。'">
                      <font-awesome-icon :icon="['fas', 'question-circle']" />
                    </el-tooltip>
                  </div>
                  <div class="report-media-profile-num-num">
                    <span class="report-media-profile-num-digit detail">{{ post.engagement_count | addComma }}</span>
                  </div>
                </div>
                <div class="report-media-profile-num-box detail">
                  <div class="report-media-profile-num-title">
                    EGR
                    <el-tooltip>
                      <div slot="content">
                        エンゲージメント率(EngagementRate)を示しています。
                        <br />いいね数とコメント数の合計をフォロワー数で割った比率です。
                      </div>
                      <font-awesome-icon :icon="['fas', 'question-circle']" />
                    </el-tooltip>
                  </div>
                  <div class="report-media-profile-num-num">
                    <span class="report-media-profile-num-digit detail"> {{ post.average_engagement_rate }} </span>%
                  </div>
                </div>
                <div class="report-media-profile-num-box detail">
                  <div class="report-media-profile-num-title">いいね</div>
                  <div class="report-media-profile-num-num">
                    <span class="report-media-profile-num-digit detail">
                      {{ post.like_count | addComma }}
                    </span>
                  </div>
                </div>
                <div class="report-media-profile-num-box detail">
                  <div class="report-media-profile-num-title">コメント</div>
                  <div class="report-media-profile-num-num">
                    <span class="report-media-profile-num-digit detail">
                      {{ post.comments_count | addComma }}
                    </span>
                  </div>
                </div>
                <div class="report-media-profile-num-box detail">
                  <div class="report-media-profile-num-title">
                    Price
                    <el-tooltip>
                      <div slot="content">
                        インフルエンサーの起用コストです。自由に設定できます。
                      </div>
                      <font-awesome-icon :icon="['fas', 'question-circle']" />
                    </el-tooltip>
                  </div>
                  <div class="report-media-profile-num-num">
                    <span class="report-media-profile-num-digit detail">
                      <span v-if="post.cost != null"> ¥{{ post.cost | addComma }} </span>
                      <font-awesome-icon v-else :icon="['far', 'hourglass-half']" style="color: #aaa; font-size: 12px" />
                    </span>
                  </div>
                </div>
                <div class="report-media-profile-num-box detail">
                  <div class="report-media-profile-num-title">
                    CPF
                    <el-tooltip>
                      <div slot="content">
                        フォロワー単価(Cost Per Followers)を示しています。
                        <br />コストをフォロワー数で割った数値です。
                      </div>
                      <font-awesome-icon :icon="['fas', 'question-circle']" />
                    </el-tooltip>
                  </div>
                  <div class="report-media-profile-num-num">
                    <span class="report-media-profile-num-digit detail">
                      <span v-if="post.cpf != null"> ¥{{ post.cpf }} </span>
                      <font-awesome-icon v-else :icon="['far', 'hourglass-half']" style="color: #aaa; font-size: 12px" />
                    </span>
                  </div>
                </div>
                <div class="report-media-profile-num-box detail">
                  <div class="report-media-profile-num-title">
                    CPE
                    <el-tooltip>
                      <div slot="content">
                        エンゲージメント単価(Cost Per Engagement)を示しています。
                        <br />コストをエンゲージメント数で割った数値です。
                      </div>
                      <font-awesome-icon :icon="['fas', 'question-circle']" />
                    </el-tooltip>
                  </div>
                  <div class="report-media-profile-num-num">
                    <span class="report-media-profile-num-digit detail">
                      <span v-if="post.cpe != null"> ¥{{ post.cpe }} </span>
                      <font-awesome-icon v-else :icon="['far', 'hourglass-half']" style="color: #aaa; font-size: 12px" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="detail-img-wrap">
              <!-- コストの関係でリールについては動画ではなくサムネイル表示とする -->
              <!-- <div v-show="post.media_type == 'GraphVideo'">
                  <video class="detail-img" :src="s3BaseUrl + '/reel/' + post.ig_id + '/' + post.media_id + '/video.mp4'" muted loop controls alt=""></video>
              </div>                
              <div v-show="post.media_type != 'GraphVideo'"> -->
              <div>
                <el-carousel class="detail-img-area" trigger="click" :arrow="post.media_type == 'GraphSidecar' ? 'hover' : 'never'" indicator-position="none" :autoplay="false" :loop="false">                                              
                  <el-carousel-item>
                    <el-image :src="s3BaseUrl + '/postdata/' + post.shortcode + '.jpg'" class="detail-img report">
                      <div slot="error" class="detail-img error report-media">
                        <font-awesome-icon :icon="['fas', 'exclamation-circle']" />
                      </div>
                    </el-image>
                  </el-carousel-item>                              
                  <el-carousel-item v-for="children in post.children" :key="children">
                    <el-image :src="children" class="detail-img report">
                      <div slot="error" class="detail-img error report-media">
                        <font-awesome-icon :icon="['fas', 'exclamation-circle']" />
                        <span style="font-size:10px; margin-top:20px">
                          Instagramで閲覧してください。
                        </span>
                      </div>
                    </el-image>
                  </el-carousel-item>
                </el-carousel>
              </div>
              
              <div class="pr_type drawer" v-show="post.pr_flag"><div class="pr_tag">PR</div></div>
              <div class="media_type" v-show="post.media_type == 'GraphVideo' && (post.s3_url == 'feed' || post.s3_url == null)">
                <font-awesome-icon :icon="['far', 'play']" class="media_tag" />
              </div>
              <div class="media_type" v-show="post.media_type == 'GraphVideo' && post.s3_url == 'clips' && !detail_loading">
                <div class="media_tag"><img src="../../assets/reels.png" class="media_type-reels w-14" alt /></div>
              </div>
              <div class="media_type" v-show="post.media_type == 'GraphSidecar'">
                <font-awesome-icon :icon="['far', 'clone']" class="media_tag" />
              </div>
              <div class="detail-tagged-user-area">
                <div class="tagged-user-icon-wrap">
                  <div class="tagged-user-icon" v-show="post.tagged_user" @click="tagged_user = !tagged_user">
                    <font-awesome-icon :icon="['fas', 'user-friends']" />
                  </div>
                </div>
                <transition name="fade">
                  <div class="tagged-user-wrap" v-show="tagged_user">
                    <div class="tagged-user" v-for="tag in post.tagged_user" :key="tag">
                      {{ tag }}
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </div>
          <div class="detail-report-right">
            <div class="detail-caption-area report">
              <pre class="caption-in report">{{ post.caption }}</pre>
            </div>
          </div>
        </div>
        <div class="detail-report-bottom">
          <div class="detail-report-engagement-title">
            <div class="detail-report-engagement-circle">
              <font-awesome-icon :icon="['far', 'chart-line']" />
            </div>
            <div>エンゲージメント推移</div>
          </div>
          <ReportDetailGraph v-if="!graphdetail_loading" :height="'300'" :graphdetail_data="graphdetail_data" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const loadReportMediaGraphAPI = root + "/api/report/load_report_mediagraph";

import ReportDetailGraph from "../charts/ReportDetailGraph";

export default {
  name: "reportPostDrawer",
  components: {
    ReportDetailGraph,
  },
  props: ["report_id", "post_list", "influencer", "post_num", "post_drawer"],
  data() {
    return {
      mounted: false,
      tagged_user: false,
      target_index: 0,
      graphdetail_loading: true,
      graphdetail_data: [],
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    post() {
      return this.post_list[this.target_index];
    },
  },
  mounted() {
    this.mounted = true;
  },
  methods: {
    addKeyDown() {
      document.addEventListener("keydown", this.onKeyDown);
    },
    removeKeyDown() {
      document.removeEventListener("keydown", this.onKeyDown);
    },
    openInfluencer(account_name){
      this.$emit("openInfluencer", account_name);
    },
    closeMedia() {
      this.$emit("closeMedia");
    },
    imgError() {
      this.influencer.profile_picture_url = this.s3BaseUrl + "/userdata/img_error.png";
    },
    onKeyDown(event) {
      if (event.key == "Esc") this.closeMedia();
      if (event.key == "Enter") this.closeMedia();
    },
    transitionMedia(type) {
      if (type == "plus" && this.target_index < this.post_list.length - 1) {
        this.target_index += 1;
      } else if (type == "minus" && this.target_index > 0) {
        this.target_index -= 1;
      }
    },
    loadGraph() {
      this.graphdetail_loading = true;
      this.axios
        .get(loadReportMediaGraphAPI, {
          params: {
            report_id: this.report_id,
            media_id: this.post_list[this.target_index].media_id,
            token: this.token,
          },
        })
        .then((response) => {
          this.graphdetail_data = response.data;
          this.graphdetail_loading = false;
        });
    },
    reportDetailHeight(media_type) {
      if(media_type == "GraphVideo") {
        return "height: auto; min-height: 828px;";
      } else {
        return "";
      }
    },
  },
  beforeDestroy() {
    this.removeKeyDown();
  },
  watch: {
    post_drawer() {
      if (this.post_drawer == true) {
        this.addKeyDown();
        this.loadGraph();
      }
      if (this.post_drawer == false) {
        this.removeKeyDown();
        this.target_index = 0;
      }
    },
    target_index() {
      if (this.post_drawer)this.loadGraph();
    },
    post: {
      handler() {
        if (this.post_drawer)this.loadGraph();
      },
      deep: true,
    },
  },
  filters: {
    addComma(val) {
      if (isNaN(val)) {
        return val;
      } else {
        return Math.floor(val).toLocaleString();
      }
    },
  },
};
</script>
